export default __webpack_public_path__ + "static/media/pa2.05b0b65c.png";